import { render, staticRenderFns } from "./list.vue?vue&type=template&id=e9dce586&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9dce586')) {
      api.createRecord('e9dce586', component.options)
    } else {
      api.reload('e9dce586', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=e9dce586&", function () {
      api.rerender('e9dce586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/icon/list.vue"
export default component.exports